<template>
    <Modal2
        v-if="visible"
        title="WhatsApp V3 Başlangıç Mesajı"
        description="Sohbet başlatmak için bir başlangıç mesajı girmeniz gerekmektedir"
        cancel-text="Vazgeç"
        ok-text="Sohbet Başlat"
        design="v2"
        class-name="initial-message-modal"
        @cancel="cancel"
        @ok="confirm"
        :show-footer="false"
    >
        <div class="initial-message-content">
            <div class="whatsapp-info-card">
                <div class="card-icon">
                    <div class="whatsapp-icon">
                        <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                            <path
                                d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.893 3.346"
                                fill="#25D366"
                            />
                        </svg>
                    </div>
                </div>
                <div class="card-content">
                    <h4>WhatsApp V3 Kanalı</h4>
                    <p>
                        Bu kanal türü için sohbet başlatırken bir başlangıç mesajı gereklidir. Bu mesaj, karşı tarafa
                        gönderilen ilk mesaj olacaktır.  Eğer boş bırakırsanız karşı tarafa bir adet boşluk içeren boş  mesaj iletilecektir.
                    </p>
                </div>
            </div>

            <div class="message-input-section">
                <div class="input-header">
                    <label>Başlangıç Mesajı</label>
                    <span class="required-badge">Önemli</span>
                </div>
                <div class="message-input-wrapper">
                    <a-textarea
                        v-model="initialMessage"
                        placeholder="Merhaba! Size nasıl yardımcı olabilirim?"
                        :rows="4"
                        :maxlength="500"
                        show-count
                        class="message-textarea"
                        ref="messageInput"
                    />
                </div>
                
            </div>

            <div class="preview-section" v-if="initialMessage.trim()">
                <h5>Önizleme</h5>
                <div class="message-preview">
                    <div class="preview-bubble">
                        <div class="bubble-content">{{ initialMessage.trim() }}</div>
                        <div class="bubble-time">Şimdi</div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-actions">
            <a-button @click="cancel" class="cancel-btn"> Vazgeç </a-button>
            <a-button 
                v-if="isValid" 
                type="primary" 
                @click="confirm" 
                :loading="isProcessing" 
                class="confirm-btn"
            >
                <span v-if="!isProcessing">Sohbet Başlat</span>
                <span v-else>Başlatılıyor...</span>
            </a-button>
            <a-button 
                v-if="!isValid"
                type="primary" 
                @click="confirmWithEmptyMessage" 
                :loading="isProcessing" 
                class="confirm-btn empty-message-btn"
            >
                <span v-if="!isProcessing">Sohbet Başlat (Boş Mesaj ile)</span>
                <span v-else>Başlatılıyor...</span>
            </a-button>
        </div>
    </Modal2>
</template>

<script>
import Vue from "vue";
import { systemMessageStream } from "../../utils/systemPubSub";
import { filter } from "rxjs/operators";
import ChatWatcher from "../../ChatWatcherV2";
import Modal2 from "../common/Modal2.vue";

export default Vue.extend({
    name: "InitialMessageModal",
    components: {
        Modal2,
    },
    data() {
        return {
            visible: false,
            initialMessage: "",
            isProcessing: false,
            chatData: {},
        };
    },
    computed: {
        isValid() {
            return this.initialMessage && this.initialMessage.trim().length > 0;
        },
    },
    methods: {
        cancel() {
            this.visible = false;
            this.initialMessage = "";
            this.chatData = {};
            this.isProcessing = false;
        },
        confirm() {
            if (!this.isValid) return;

            this.isProcessing = true;
            const updatedData = {
                ...this.chatData,
                defaultInitialMessage: this.initialMessage.trim(),
            };

            // ChatWatcher'a güncellenmiş data ile tekrar çağrı yap
            ChatWatcher.startChatImmediately(updatedData);

            // Modal'ı kapat ve temizle
            this.visible = false;
            this.initialMessage = "";
            this.chatData = {};
            this.isProcessing = false;
        },
        confirmWithEmptyMessage() {
            this.isProcessing = true;
            const updatedData = {
                ...this.chatData,
                defaultInitialMessage: "⠀",
                passInitialMessage: false,
            };

            // ChatWatcher'a güncellenmiş data ile tekrar çağrı yap
            ChatWatcher.startChatImmediately(updatedData);

            // Modal'ı kapat ve temizle
            this.visible = false;
            this.initialMessage = "";
            this.chatData = {};
            this.isProcessing = false;
        },
        showModal(data) {
            this.chatData = data;
            this.visible = true;
            this.$nextTick(() => {
                if (this.$refs.messageInput && this.$refs.messageInput.$el) {
                    const textarea = this.$refs.messageInput.$el.querySelector("textarea");
                    if (textarea) {
                        textarea.focus();
                    }
                }
            });
        },
    },
    created() {
        // System message stream'i dinle
        this.subscription = systemMessageStream
            .pipe(filter((x) => x.type === "SHOW_INITIAL_MESSAGE_MODAL"))
            .subscribe((x) => {
                this.showModal(x.payload.data);
            });
    },
    beforeDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    },
});
</script>

<style scoped lang="scss">
.initial-message-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
}

.whatsapp-info-card {
    display: flex;
    align-items: flex-start;
    gap: 16px;
    padding: 20px;
    background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
    border: 1px solid #bae6fd;
    border-radius: 12px;
    position: relative;
    overflow: hidden;

    &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        background: linear-gradient(90deg, #25d366 0%, #128c7e 100%);
    }

    .card-icon {
        flex-shrink: 0;

        .whatsapp-icon {
            width: 48px;
            height: 48px;
            background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);

            svg {
                filter: brightness(0) invert(1);
            }
        }
    }

    .card-content {
        flex: 1;

        h4 {
            margin: 0 0 8px 0;
            font-size: 18px;
            font-weight: 600;
            color: #0f172a;
            line-height: 1.4;
        }

        p {
            margin: 0;
            font-size: 14px;
            color: #64748b;
            line-height: 1.6;
        }
    }
}

.message-input-section {
    .input-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 12px;

        label {
            font-size: 16px;
            font-weight: 600;
            color: #1e293b;
            margin: 0;
        }

        .required-badge {
            background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
            color: white;
            padding: 4px 10px;
            border-radius: 20px;
            font-size: 11px;
            font-weight: 600;
            text-transform: uppercase;
            letter-spacing: 0.5px;
        }
    }

    .message-input-wrapper {
        position: relative;

        .message-textarea {
            border-radius: 12px;
            border: 2px solid #e2e8f0;
            transition: all 0.3s ease;

            textarea {
                font-size: 15px;
                line-height: 1.6;
                padding: 16px;
                border-radius: 10px;

                &::placeholder {
                    color: #94a3b8;
                    font-style: italic;
                }

                &:focus {
                    border-color: #25d366;
                    box-shadow: 0 0 0 3px rgba(37, 211, 102, 0.1);
                }
            }

            &:hover {
                border-color: #cbd5e1;
            }
        }
    }

    .input-tips {
        display: flex;
        gap: 16px;
        margin-top: 12px;

        .tip-item {
            display: flex;
            align-items: center;
            gap: 8px;
            font-size: 13px;
            color: #64748b;

            .tip-icon {
                font-size: 14px;
            }
        }
    }
}

.preview-section {
    h5 {
        margin: 0 0 12px 0;
        font-size: 14px;
        font-weight: 600;
        color: #475569;
    }

    .message-preview {
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        border-radius: 12px;
        padding: 16px;

        .preview-bubble {
            background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
            color: white;
            padding: 12px 16px;
            border-radius: 18px 18px 18px 4px;
            max-width: 280px;
            position: relative;

            .bubble-content {
                font-size: 14px;
                line-height: 1.4;
                word-break: break-word;
            }

            .bubble-time {
                font-size: 11px;
                opacity: 0.8;
                text-align: right;
                margin-top: 4px;
            }

            &::after {
                content: "";
                position: absolute;
                bottom: 0;
                left: -8px;
                width: 0;
                height: 0;
                border: 8px solid transparent;
                border-right-color: #25d366;
                border-bottom-color: #25d366;
                border-left: none;
                border-bottom: none;
            }
        }
    }
}

.modal-actions {
    display: flex;
    gap: 12px;
    justify-content: flex-end;
    width: 100%;
    flex-wrap: wrap;
    align-items: center;

    // Responsive düzenlemeler
    @media (max-width: 768px) {
        justify-content: center;
        gap: 8px;
    }

    @media (max-width: 480px) {
        flex-direction: column;
        gap: 10px;
        
        .cancel-btn,
        .confirm-btn {
            width: 100%;
            max-width: 280px;
        }
    }

    .cancel-btn {
        min-width: 100px;
        height: 40px;
        border-radius: 8px;
        font-weight: 500;
    }

    .confirm-btn {
        min-width: 140px;
        height: 40px;
        border-radius: 8px;
        font-weight: 600;
        background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
        border: none;
        box-shadow: 0 4px 12px rgba(37, 211, 102, 0.3);

        &:hover {
            background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
            box-shadow: 0 6px 16px rgba(37, 211, 102, 0.4);
            transform: translateY(-1px);
        }

        &:disabled {
            background: #94a3b8;
            box-shadow: none;
            transform: none;
        }

        &.empty-message-btn {
            min-width: 220px;
            max-width: 250px;
            width: auto;
            height: 44px;
            padding: 8px 16px;
            background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
            box-shadow: 0 4px 12px rgba(245, 158, 11, 0.3);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-size: 13px;
            line-height: 1.2;
            display: flex;
            align-items: center;
            justify-content: center;

            span {
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                max-width: 100%;
                display: inline-block;
            }

            &:hover {
                background: linear-gradient(135deg, #f97316 0%, #ea580c 100%);
                box-shadow: 0 6px 16px rgba(245, 158, 11, 0.4);
            }

            // Responsive düzenlemeler
            @media (max-width: 768px) {
                min-width: 200px;
                font-size: 12px;
                padding: 8px 12px;
            }

            @media (max-width: 480px) {
                min-width: 180px;
                font-size: 11px;
                padding: 8px 10px;
            }
        }
    }
}

// Global modal düzenlemeleri
:global(.initial-message-modal.v3) {
    .custom-modal-header {
        background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
        border-bottom: 1px solid #e2e8f0;
    }

    .custom-modal-body {
        background: #ffffff;
        padding: 24px !important;
    }

    .custom-modal-footer {
        background: #f8fafc;
        border-top: 1px solid #e2e8f0;
    }
}
</style>
